import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from 'investira.react.components';

/**
 * Renderiza o componente CloseIconButton.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.size - Tamanho aplicado ao componente ou ícone.
 * @param {string} props.color - Cor usada na renderização do componente.
 * @param {Function} props.onClick - Callback executado ao clicar no componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const CloseIconButton = memo(props => {
    const { onClick, size, color } = props;

    return (
        <IconButton onClick={onClick}>
            <Icon iconName="cancel" size={size} color={color} />
        </IconButton>
    );
});

CloseIconButton.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    onClick: PropTypes.func
};

CloseIconButton.defaultProps = {
    size: 22,
    color: 'primary'
};

export default CloseIconButton;
